

import React from "react"

/**
 * Region East svg icon with defined properties as per UI
 * @returns EastSvg JSX
 */

export const EastSvg = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="26" height="26" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.81447 1.09375L17.3437 5.87296L7.81446 10.5939L9.44639 5.87296L7.81447 1.09375ZM15.4844 5.83814L10.6177 5.83814L9.74349 2.95312L15.4844 5.83814Z" fill="#717171" />
            <path d="M9 24V12H16.9769V14.0918H11.5029V16.9512H16.5665V19.043H11.5029V21.9082H17V24H9Z" fill="#717171" />
        </svg>
    )
}
